import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

import { WHATSAPP_NUMBER } from "@/lib/socialLinks";
const MESSENGER_URL = "https://m.me/plymhairextensions";

const FloatingChat = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-live-chat", handler);
    return () => window.removeEventListener("open-live-chat", handler);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col gap-2 animate-in fade-in slide-in-from-bottom-2 duration-200">
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20Plymhair%2C%20I%20have%20a%20question!`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all"
          >
            <svg viewBox="0 0 24 24" width={22} height={22} fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            <span className="font-semibold text-sm">WhatsApp</span>
          </a>
          <a
            href={MESSENGER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#0084FF] text-white px-4 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all"
          >
            <svg viewBox="0 0 24 24" width={22} height={22} fill="currentColor">
              <path d="M12 0C5.373 0 0 4.974 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.3 2.246.464 3.443.464 6.627 0 12-4.975 12-11.111C24 4.974 18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8.2l3.131 3.259L19.752 8.2l-6.561 6.763z" />
            </svg>
            <span className="font-semibold text-sm">Messenger</span>
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="group flex items-center gap-1.5 sm:gap-2 bg-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-105 transition-all rounded-full p-2.5 sm:pl-4 sm:pr-2 sm:py-2"
        aria-label={open ? "Close chat options" : "Chat with us"}
      >
        {open ? (
          <>
            <span className="hidden sm:inline text-sm font-semibold">Close</span>
            <span className="w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-primary-foreground/20 flex items-center justify-center">
              <X size={16} />
            </span>
          </>
        ) : (
          <>
            <span className="hidden sm:relative sm:flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400" />
            </span>
            <span className="hidden sm:inline text-sm font-semibold">Live Chat</span>
            <span className="relative w-7 h-7 sm:w-10 sm:h-10 rounded-full bg-primary-foreground/20 flex items-center justify-center">
              <MessageCircle size={16} className="sm:hidden" /><MessageCircle size={20} className="hidden sm:block" />
              <span className="absolute -top-0.5 -right-0.5 flex h-3 w-3 sm:hidden">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-400 border-2 border-primary" />
              </span>
            </span>
          </>
        )}
      </button>
    </div>
  );
};

export default FloatingChat;
